import { CSSProperties, PropsWithChildren } from "react";

type Props = PropsWithChildren<object>;

export default function NavbarButtonsContainer({ children }: Props) {
  const styles: CSSProperties = {
    position: "relative",
    zIndex: "var(--z-index-header-navbar-buttons)",
    display: "flex",
    alignItems: "center",
  };

  return <div style={styles}>{children}</div>;
}
